function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { WINDOW, toCamelCase, toKebabCase, isNaN, isUndefined, isNumber, emit, nextTick, isObject, IS_BROWSER } from '@cropper/utils';
var style = ":host([hidden]){display:none!important}";
var REGEXP_SUFFIX = /left|top|width|height/i;
var DEFAULT_SHADOW_ROOT_MODE = 'open';
var shadowRoots = new WeakMap();
var styleSheets = new WeakMap();
var tagNames = new Map();
var supportsAdoptedStyleSheets = WINDOW.document && Array.isArray(WINDOW.document.adoptedStyleSheets) && 'replaceSync' in WINDOW.CSSStyleSheet.prototype;

var CropperElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CropperElement, _HTMLElement);

  var _super = _createSuper(CropperElement);

  function CropperElement() {
    var _this;

    _classCallCheck(this, CropperElement);

    var _a, _b;

    _this = _super.call(this);
    _this.shadowRootMode = DEFAULT_SHADOW_ROOT_MODE;
    _this.slottable = true;
    var name = (_b = (_a = Object.getPrototypeOf(_assertThisInitialized(_this))) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.$name;

    if (name) {
      tagNames.set(name, _this.tagName.toLowerCase());
    }

    return _this;
  }

  _createClass(CropperElement, [{
    key: "$sharedStyle",
    get: function get() {
      return "".concat(this.themeColor ? ":host{--theme-color: ".concat(this.themeColor, ";}") : '').concat(style);
    }
  }, {
    key: "attributeChangedCallback",
    value: // Convert attribute to property
    function attributeChangedCallback(name, oldValue, newValue) {
      if (Object.is(newValue, oldValue)) {
        return;
      }

      var propertyName = toCamelCase(name);
      var oldPropertyValue = this[propertyName];
      var newPropertyValue = newValue;

      switch (_typeof(oldPropertyValue)) {
        case 'boolean':
          newPropertyValue = newValue !== null && newValue !== 'false';
          break;

        case 'number':
          newPropertyValue = Number(newValue);
          break;
      }

      this[propertyName] = newPropertyValue;

      switch (name) {
        case 'theme-color':
          {
            var styleSheet = styleSheets.get(this);
            var styles = this.$sharedStyle;

            if (styleSheet && styles) {
              if (supportsAdoptedStyleSheets) {
                styleSheet.replaceSync(styles);
              } else {
                styleSheet.textContent = styles;
              }
            }

            break;
          }
      }
    } // Convert property to attribute

  }, {
    key: "$propertyChangedCallback",
    value: function $propertyChangedCallback(name, oldValue, newValue) {
      if (Object.is(newValue, oldValue)) {
        return;
      }

      name = toKebabCase(name);

      switch (_typeof(newValue)) {
        case 'boolean':
          if (newValue === true) {
            if (!this.hasAttribute(name)) {
              this.setAttribute(name, '');
            }
          } else {
            this.removeAttribute(name);
          }

          break;

        case 'number':
          if (isNaN(newValue)) {
            newValue = '';
          } else {
            newValue = String(newValue);
          }

        // Fall through
        // case 'string':
        // eslint-disable-next-line no-fallthrough

        default:
          if (newValue) {
            if (this.getAttribute(name) !== newValue) {
              this.setAttribute(name, newValue);
            }
          } else {
            this.removeAttribute(name);
          }

      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      // Observe properties after observed attributes
      Object.getPrototypeOf(this).constructor.observedAttributes.forEach(function (attribute) {
        var property = toCamelCase(attribute);
        var value = _this2[property];

        if (!isUndefined(value)) {
          _this2.$propertyChangedCallback(property, undefined, value);
        }

        Object.defineProperty(_this2, property, {
          enumerable: true,
          configurable: true,
          get: function get() {
            return value;
          },
          set: function set(newValue) {
            var oldValue = value;
            value = newValue;
            this.$propertyChangedCallback(property, oldValue, newValue);
          }
        });
      });
      var shadow = this.shadowRoot || this.attachShadow({
        mode: this.shadowRootMode || DEFAULT_SHADOW_ROOT_MODE
      });
      shadowRoots.set(this, shadow);
      styleSheets.set(this, this.$addStyles(this.$sharedStyle));

      if (this.$style) {
        this.$addStyles(this.$style);
      }

      if (this.$template) {
        var template = document.createElement('template');
        template.innerHTML = this.$template;
        shadow.appendChild(template.content);
      }

      if (this.slottable) {
        var slot = document.createElement('slot');
        shadow.appendChild(slot);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (styleSheets.has(this)) {
        styleSheets.delete(this);
      }

      if (shadowRoots.has(this)) {
        shadowRoots.delete(this);
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "$getTagNameOf",
    value: function $getTagNameOf(name) {
      var _a;

      return (_a = tagNames.get(name)) !== null && _a !== void 0 ? _a : name;
    }
  }, {
    key: "$setStyles",
    value: function $setStyles(properties) {
      var _this3 = this;

      Object.keys(properties).forEach(function (property) {
        var value = properties[property];

        if (isNumber(value)) {
          if (value !== 0 && REGEXP_SUFFIX.test(property)) {
            value = "".concat(value, "px");
          } else {
            value = String(value);
          }
        }

        _this3.style[property] = value;
      });
      return this;
    }
    /**
     * Outputs the shadow root of the element.
     * @returns {ShadowRoot} Returns the shadow root.
     */

  }, {
    key: "$getShadowRoot",
    value: function $getShadowRoot() {
      return this.shadowRoot || shadowRoots.get(this);
    }
    /**
     * Adds styles to the shadow root.
     * @param {string} styles The styles to add.
     * @returns {CSSStyleSheet|HTMLStyleElement} Returns the generated style sheet.
     */

  }, {
    key: "$addStyles",
    value: function $addStyles(styles) {
      var styleSheet;
      var shadow = this.$getShadowRoot();

      if (supportsAdoptedStyleSheets) {
        styleSheet = new CSSStyleSheet();
        styleSheet.replaceSync(styles);
        shadow.adoptedStyleSheets = shadow.adoptedStyleSheets.concat(styleSheet);
      } else {
        styleSheet = document.createElement('style');
        styleSheet.textContent = styles;
        shadow.appendChild(styleSheet);
      }

      return styleSheet;
    }
    /**
     * Dispatches an event at the element.
     * @param {string} type The name of the event.
     * @param {*} [detail] The data passed when initializing the event.
     * @param {CustomEventInit} [options] The other event options.
     * @returns {boolean} Returns the result value.
     */

  }, {
    key: "$emit",
    value: function $emit(type, detail, options) {
      return emit(this, type, detail, options);
    }
    /**
     * Defers the callback to be executed after the next DOM update cycle.
     * @param {Function} [callback] The callback to execute after the next DOM update cycle.
     * @returns {Promise} A promise that resolves to nothing.
     */

  }, {
    key: "$nextTick",
    value: function $nextTick(callback) {
      return nextTick(this, callback);
    }
    /**
     * Defines the constructor as a new custom element.
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/define}
     * @param {string|object} [name] The element name.
     * @param {object} [options] The element definition options.
     */

  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['shadow-root-mode', 'slottable', 'theme-color'];
    }
  }, {
    key: "$define",
    value: function $define(name, options) {
      if (isObject(name)) {
        options = name;
        name = '';
      }

      if (!name) {
        name = this.$name || this.name;
      }

      name = toKebabCase(name);

      if (IS_BROWSER && WINDOW.customElements && !WINDOW.customElements.get(name)) {
        customElements.define(name, this, options);
      }
    }
  }]);

  return CropperElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

CropperElement.$version = '2.1.0';
export { CropperElement as default };